import React, { useState } from 'react';
import { Select, MenuItem, SelectChangeEvent, useTheme, Stack, styled } from '@mui/material';
import { UserRoles } from 'constants/userRoles';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAuthContext } from 'hooks/useAuthContext';
import { WorkspaceContextMenu } from 'components/WorkspaceContextMenu';
import { StyledWorkspaceSelect } from './WorkspaceDropdown.styles';

const StyledBoldWorkspaceSelect = styled(StyledWorkspaceSelect)({
  fontWeight: 'bold'
});

const StyledBoldMenuItem = styled(MenuItem)({
  fontWeight: 'bold'
});

export const WorkspaceDropdown = () => {
  const { userState, changeWorkspace } = useAuthContext();
  const theme = useTheme();

  return <Stack display='flex' flexDirection={'row'} alignItems={'center'} alignContent={'center'} justifyContent={'center'}>    
    <StyledBoldWorkspaceSelect 
    value={userState.user.selectedWorkspace.workspaceId} 
      onChange={(e: SelectChangeEvent<unknown>) => changeWorkspace(e.target.value as string)}
      variant="outlined"
      disabled={userState.user.selectedWorkspace.userRole !== UserRoles.ADMIN}
      IconComponent={KeyboardArrowDownIcon}
      size='small'
    >
      {userState.user.associatedWorkspaces.map(workspace => (
        <StyledBoldMenuItem key={workspace.id} value={workspace.id}>{workspace.name}</StyledBoldMenuItem>
      ))}
    </StyledBoldWorkspaceSelect>
    {userState.user.selectedWorkspace.userRole === UserRoles.ADMIN && <WorkspaceContextMenu />}
  </Stack>
  ;
}

export default WorkspaceDropdown;